import { ReactNode, ReactElement } from 'react';

/**
 * Unique brand to mark the <Variant> component type.
 * Using a Symbol avoids name collisions and survives minification.
 */
export const VARIANT_BRAND: unique symbol = Symbol('ExperimentVariant');

export type VariantProps = {
  name: string;
  isControl?: boolean;
  children?: ReactNode;
};

/**
 * Variant component — only valid direct child (or descendant via Fragment) of <Experiment>.
 */
export type VariantComponent = ((props: VariantProps) => ReactElement | null) & {
  [VARIANT_BRAND]: true;
  displayName?: string;
};

export const Variant: VariantComponent = (({ children }) => {
  return <>{children}</>;
}) as VariantComponent;

Variant[VARIANT_BRAND] = true;
Variant.displayName = 'Variant';
